import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { renderTableTitle } from "@/utils/render.jsx";
import PositionStructureAdd from "@/views/MGT/position/components/position-structure-add.vue";
import { tagAssociatePage, deleteTagAssociateById } from "@/service/structure.js";
export default {
  name: "position-list",
  components: {
    PositionStructureAdd
  },
  props: {
    position: {
      type: Object,
      default() {
        return {};
      }
    },
    searchValue: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    const h = this.$createElement;
    return {
      structure: {
        visible: false
      },
      tableSelectList: [],
      config: {
        map: {
          dataPath: "retVal.datas",
          message: "msg",
          totalPath: "retVal.totalRows"
        },
        ref: "proTable",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: async search => {
          if (this.position.tagId) {
            let params = {
              ...search,
              tagId: this.position.tagId,
              search: this.searchValue
            };
            let {
              data
            } = await tagAssociatePage(params);
            if (data && data.result === 0) {
              this.tableSelectList = [];
            }
            return data;
          }
        },
        columns: [{
          type: "selection",
          width: 60,
          align: "center",
          notShowTable: this.$store.state.user.userInfo.isAdmin !== "T"
        }, {
          // lg: 名称
          title: $t("eyrn2", "名称"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          minWidth: 200,
          notShowSearch: true,
          notShowForm: true,
          render: (item, {
            row
          }) => {
            return h("span", [row.targetType === "USER" ? h("span", [row.targetDescription]) : h("span", [row.targetDescription])]);
          }
        }, {
          // lg: 部门
          title: $t("pgxs2", "部门"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "targetOrganization",
          notShowSearch: true,
          notShowForm: true,
          tooltip: true
        }],
        table: {
          stripe: false,
          "show-summary": false,
          height: window.innerHeight - 252,
          border: false
        },
        page: {
          "show-elevator": false
        },
        hide: {
          search: true,
          toolBar: true
        }
      }
    };
  },
  computed: {
    _buttonShow() {
      return this.tableSelectList.length > 0;
    },
    isAdmin() {
      return this.$store.state.user.userInfo.isAdmin === "T";
    }
  },
  watch: {
    "position.tagId": function () {
      this.onSearchStatr();
    },
    searchValue() {
      this.onSearchStatr();
    }
  },
  methods: {
    onOpen() {
      this.structure.visible = true;
    },
    onSearchStatr() {
      this.$refs[this.config.ref].searchAction();
    },
    async onDelete() {
      const params = {
        ids: this.tableSelectList.map(item => item.id).join(",")
      };
      let res = await deleteTagAssociateById(params);
      if (res.data && res.data.result === 0) {
        // lg: 移除成功
        this.$Message.success($t("g0dcew4", "移除成功"));
        let proTableRef = this.$refs.proTable;
        if (proTableRef.proData.length === this.tableSelectList.length && proTableRef.page.current > 1) {
          proTableRef.page.current -= 1;
        }
        this.$refs[this.config.ref].fetch();
        this.tableSelectList = [];
      }
    },
    onAddPosition() {
      this.$emit("onAddPosition");
    },
    onOnSelectionChange(selection) {
      this.tableSelectList = selection;
    }
  }
};